import { render } from "./buttonLightBig.vue?vue&type=template&id=588b760f"
import script from "./buttonLightBig.vue?vue&type=script&lang=js"
export * from "./buttonLightBig.vue?vue&type=script&lang=js"

import "./buttonLightBig.vue?vue&type=style&index=0&id=588b760f&lang=css"

import exportComponent from "/Users/matjeez/Matjez/Projects/websites/simonkr-feb24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__